<template>
    <v-dialog v-model="dialog" max-width="800px">
        <v-card>
            <v-toolbar title="Enviar solicitud a realizar" class="modal-header"></v-toolbar>
            
            <v-card-text class="pt-6">
                <!-- Información del efector actual -->
                <v-alert 
                    type="info" 
                    variant="tonal"
                    class="mb-4"
                >
                    <div class="d-flex align-center">
                        <div>
                            <p class="mb-1"><strong>Efector actual de la solicitud:</strong></p>
                            <p class="mb-0">{{ efectorActual }}</p>
                        </div>
                    </div>
                </v-alert>

                <!-- Pregunta al usuario -->
                <v-row class="mb-4">
                    <v-col cols="12">
                        <h4>¿Qué desea hacer?</h4>
                        <v-radio-group v-model="opcionSeleccionada" mandatory>
                            <v-radio value="actual" color="primary">
                                <template v-slot:label>
                                    <strong>Enviar a realizar con el efector actual</strong>
                                </template>
                            </v-radio>
                            <v-radio value="otro" color="primary">
                                <template v-slot:label>
                                    <strong>Declarar otro efector</strong>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>

                <!-- Selector de nuevo efector (solo se muestra si selecciona "otro") -->
                <v-expand-transition>
                    <div v-if="opcionSeleccionada === 'otro'">
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                            <v-col cols="12" md="4">
                                <h4 class="my-text-black">Datos del profesional efector</h4>
                            </v-col>
                            <v-col cols="12" md="8">
                                <p text-h5 class="font-weight-light">Busque por nombre o matrícula</p>
                            </v-col>
                        </v-row>
                        
                        <v-autocomplete
                            required
                            class="asterisco mb-4"
                            :rules="opcionSeleccionada === 'otro' ? obligatorio : []"
                            label="Matricula - Apellido y Nombre"
                            :items="profesionalesFacturador"
                            return-object
                            :item-title="itemTitlePrescriptor"
                            variant="solo"
                            v-model="profesionalEfector"
                            auto-select-first="true"
                            no-data-text="No se encontraron resultados"
                            :menu-props="{width: 200}"
                            @update:modelValue="onProfesionalChange"
                            :loading="cargandoEfector"
                        ></v-autocomplete>
                        
                        <EspecialidadOptions
                            ref="especialidadOptions"
                            :obligatorio="opcionSeleccionada === 'otro' ? obligatorio : []"
                            :idProfesional="profesionalEfector ? profesionalEfector.id : null"
                            @especialidadSeleccionada="onEspecialidadChange($event)"
                        ></EspecialidadOptions>
                    </div>
                </v-expand-transition>
            </v-card-text>

            <v-card-actions class="justify-end pa-4">
                <v-btn
                    text="Cancelar"
                    variant="text"
                    @click="cerrarModal"
                ></v-btn>
                <v-btn
                    id="boton-verde"
                    text="Enviar a realizar"
                    :disabled="!puedeEnviar"
                    :loading="enviando"
                    @click="enviarARealizar"
                ></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped src="../assets/general.css">
.my-text-black {
    color: #000000;
}

.asterisco::after {
    content: " *";
    color: red;
}

#boton-verde {
    background-color: #244125;
    color: white;
}
</style>

<script>
import EspecialidadOptions from './EspecialidadOptions.vue';

export default {
    name: 'ModalEnviarRealizar',
    components: {
        EspecialidadOptions
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        idSolicitud: {
            type: Number,
            required: true
        },
        efectorActual: {
            type: String,
            required: true
        },
        profesionalesFacturador: {
            type: Array,
            default: () => []
        },
        cargandoEfector: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            opcionSeleccionada: 'actual',
            profesionalEfector: null,
            especialidadSeleccionada: null,
            enviando: false,
            obligatorio: [
                v => !!v || 'Este campo es obligatorio'
            ]
        };
    },
    computed: {
        dialog: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },
        puedeEnviar() {
            if (this.opcionSeleccionada === 'actual') {
                return true;
            } else {
                return this.profesionalEfector && this.especialidadSeleccionada;
            }
        }
    },
    methods: {
        itemTitlePrescriptor(item) {
            if (!item) return '';
            if(item.matriculaProvincial){
                return `${item.matriculaProvincial} - ${item.apellidos} ${item.nombres}`;
            }
            else{
                return `${item.matriculaNacional} - ${item.apellidos} ${item.nombres}`;
            }
        },
        onProfesionalChange(){
            if(this.profesionalEfector){
                this.$refs.especialidadOptions.getEspecialidadesProfesional(this.profesionalEfector.id)
            }
        },
        onEspecialidadChange(especialidad) {
            this.especialidadSeleccionada = especialidad;
        },
        async enviarARealizar() {
            this.enviando = true;
            
            const datos = {
                idSolicitud: this.idSolicitud,
                mantenerEfector: this.opcionSeleccionada === 'actual',
                nuevoEfector: this.opcionSeleccionada === 'otro' ? {
                    idProfesional: this.profesionalEfector.id,
                    idEspecialidad: this.especialidadSeleccionada.id
                } : null
            };
            console.log('Datos a enviar:', datos);
            this.$emit('enviar', datos);
            this.enviando = false;
        },
        cerrarModal() {
            this.resetearFormulario();
            this.dialog = false;
        },
        resetearFormulario() {
            this.opcionSeleccionada = 'actual';
            this.profesionalEfector = null;
            this.especialidadSeleccionada = null;
        }
    },
    watch: {
        modelValue(newVal) {
            if (!newVal) {
                this.resetearFormulario();
            }
        }
    }
};
</script>
